import React, { useMemo } from "react";

import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import glassesService from "../../../services/glasses.service";

// import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
// import ObjectModalContent from "../glasses-colors/object";

export default function GlassesSizesPage(props) {
  const { data, glasses, onRefresh } = props;

  const deleteItem = (item) => {
    return glassesService.deleteGlassesSize(item.id);
  };
  const headerCells = useMemo(
    () => [
      {
        field: "count",
        title: "موجودی",
        mainField: true,
      },
      {
        field: "lensSize",
        title: "طول لنز",
      },
      {
        field: "lensHeight",
        title: "ارتفاع لنز",
      },
      {
        field: "bridgeSize",
        title: "طول پل",
      },
      {
        field: "templeLength",
        title: "طول دسته",
      },
      {
        field: "hingeToHinge",
        title: "لولا به لولا",
      },
    ],
    []
  );

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        data={data.sizes}
        onRefresh={onRefresh}
        rowActions={[
          // {
          //   modalProps: { maxWidth: "sm" },
          //   icon: (p) => {
          //     return (
          //       <EmojiObjectsIcon
          //         color={p.modelObject ? "primary" : undefined}
          //       />
          //     );
          //   },
          //   modalContent: (p) => <ObjectModalContent {...p} parent={props} />,
          // },
          {
            modalProps: { maxWidth: "sm" },
            icon: <EditIcon />,
            modalContent: (p) => <FormModalContent {...p} parent={props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <AddIcon />,
            tooltip: "ایجاد سایز عینک",
            modalContent: (p) => <FormModalContent {...p} parent={props} />,
          },
        ]}
        // searchKeys={defaultKeys}
        title={`سایزهای عینک ${glasses.name} ${data.name}`}
      />
    </div>
  );
}
